import React from 'react';
import { SectionNotification, ButtonPriority } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { getMetaSiteId } from '../../../common/store/instance-values/instance-values-selectors';
import { RootState } from '../../types/store-types';
import { flowRight } from 'lodash';
import { connect } from '../../../common/components/runtime-context';
import { classes } from './deprecation-warning.st.css';
import { AlertIcon } from '../icons/alert-icon';
import withDeviceType from '../../hoc/with-device-type';

export const DeprecationWarning: React.FC<{ metaSiteId: string; isDesktop: boolean }> = ({
  metaSiteId,
  isDesktop,
}) => {
  const { t } = useTranslation();
  const dashboardUrl = `https://www.wix.com/dashboard/${metaSiteId}/wix-forum`;

  return (
    <SectionNotification type="alert" className={classes.root}>
      <SectionNotification.Icon icon={<AlertIcon className={classes.icon} />} />
      <div className={classes.textContainer}>
        <SectionNotification.Text className={classes.title}>
          {t('app.deprecation-warning.title')}
        </SectionNotification.Text>
        <SectionNotification.Text>{t('app.deprecation-warning.subtitle')}</SectionNotification.Text>
      </div>
      {isDesktop && (
        <a href={dashboardUrl} target="_blank" rel="noreferrer">
          <SectionNotification.Button priority={ButtonPriority.basicSecondary}>
            {t('app.deprecation-warning.cta')}
          </SectionNotification.Button>
        </a>
      )}
    </SectionNotification>
  );
};

const mapRuntimeToProps = (state: RootState) => ({
  metaSiteId: getMetaSiteId(state),
});

export default flowRight(withDeviceType, connect(mapRuntimeToProps))(DeprecationWarning);
